export default __webpack_public_path__ + "static/media/img_bkg_create.dcefbcf1.jpg";